import React, { Component } from 'react';
import HomepageHero from '../../components/HomepageHero';
import HomepageGuidepost from '../../components/HomepageGuidepost';
import HomepageAbout from '../../components/HomepageAbout';
import HomepageGallery from '../../components/HomepageGallery';
import Certificates from '../../components/Certificates';

class HomePage extends Component {
  render() {
    return (
      <div className="page page-homepage">
        <HomepageHero />
        <HomepageGuidepost />
        <HomepageAbout />
        <HomepageGallery />
        <Certificates />
      </div>
    );
  }
}

export default HomePage;